export default {
  props: {
    headers: {
      type: Object,
    },
    data: {
      type: Object,
    },
  },
}
